<script>
import { mapActions } from 'vuex'
import LavenderMixin from '@/mixins/lavender'

export default {
  name: 'SingleCheckoutToastItem',
  mixins: [LavenderMixin],
  props: {
    data: Proptypes.object(() => {}),
    options: Proptypes.object(() => {}),
  },
  computed: {
    content() {
      return this.data?.content || ''
    },
    isLavenderEnabled() {
      return this.isLavenderReskinEnabled
    },
    icon() {
      return this.data?.icon || 'rounded-check'
    },
  },
  methods: {
    ...mapActions('toast', ['clearToast']),
  },
  created() {
    const data = this.data
    if (this.options.isDisappearing) {
      setTimeout(() => {
        this.clearToast(data)
      }, 4000)
    }
  },
}
</script>

<template>
  <div
    :class="['toast-item', { 'toast-item_lavender': isLavenderReskinEnabled }]"
  >
    <div class="toast-item__content">
      <v-progress-circular
        v-if="options.isLoading"
        color="#9600F1"
        size="20"
        width="2"
        indeterminate
      />
      <SvgIcon v-else :name="icon" size="22px" />
      <p>
        {{ content }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/direction.scss';

.toast-item {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 8px;

  &__content {
    border-radius: 48px;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(5px);
    padding: 12px 24px 12px 14px;
    color: #fff;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;

    p {
      text-decoration: none !important;
      color: inherit;
      margin-left: 8px;
    }
  }
}

.toast-item_lavender {
  height: 54px;

  .toast-item__content {
    font-family: 'Plus Jakarta Sans', sans-serif;
    box-shadow: 0 8px 24px 0 #1928391f;
    background: #212442;
    padding: 12px 20px;
    line-height: 30px;

    p {
      margin-left: 14px;
    }
  }
}

@include for-rtl {
  .toast-item {
    &__content {
      padding: 12px 14px 12px 24px;
    }

    p {
      margin-left: 0;
      margin-right: 8px;
    }
  }

  .toast-item_lavender {
    .toast-item__content {
      font-family: 'IBM Plex Sans Arabic', sans-serif;
      padding: 12px 20px;

      p {
        margin-left: 0;
        margin-right: 14px;
      }
    }
  }
}
</style>
